import React from 'react';

interface BlogPageSkeletonProps {
  count?: number;
}

export default function BlogPageSkeleton({ count = 9 }: BlogPageSkeletonProps) {
  return (
    <div className="flex flex-col lg:flex-row gap-8">
      {/* Mobile Tag Sidebar Skeleton */}
      <div className="lg:hidden">
        <div className="bg-white rounded-lg animate-pulse">
          <div className="mb-8">
            {/* 제목 스켈레톤 */}
            <div className="mb-4">
              <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-28"></div>
            </div>
            
            {/* 태그들 스켈레톤 */}
            <div className="flex flex-wrap gap-1.5">
              {Array.from({ length: 8 }).map((_, index) => (
                <div 
                  key={index} 
                  className="h-6 bg-gray-300 dark:bg-gray-700 rounded-full w-[80px]"
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="flex-1">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 gap-y-12">
          {Array.from({ length: count }).map((_, index) => (
            <div key={index}>
              <div className="group cursor-pointer animate-pulse">
                {/* 이미지 스켈레톤 */}
                <div className="mb-4 overflow-hidden rounded-xl relative h-48 sm:h-52 md:h-48 lg:h-48 bg-gray-300 dark:bg-gray-700">
                </div>
                
                {/* 날짜 스켈레톤 */}
                <div className="mb-2">
                  <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-24"></div>
                </div>
                
                {/* 제목 스켈레톤 */}
                <div className="mb-2">
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-full mb-2"></div>
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-3/4"></div>
                </div>
                
                {/* 태그 스켈레톤 */}
                <div className="flex flex-wrap gap-1">
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-16"></div>
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-20"></div>
                  <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-12"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop Sidebar Skeleton - Right, Sticky */}
      <div className="hidden lg:block lg:w-80">
        <div className="bg-white rounded-lg lg:p-6 animate-pulse sticky top-20">
          <div className="mb-8">
            {/* 제목 스켈레톤 */}
            <div className="mb-4">
              <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-28"></div>
            </div>
            
            {/* 태그들 스켈레톤 */}
            <div className="flex flex-wrap gap-1.5">
              {Array.from({ length: 8 }).map((_, index) => (
                <div 
                  key={index} 
                  className="h-6 bg-gray-300 dark:bg-gray-700 rounded-full w-[80px]"
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 